/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
    {
        url: '/management/hospital',
        name: '병원정보',
        icon: 'ArchiveIcon',
        level_sum: 1,
    },
    {
        url: '/patient/static',
        name: '통계',
        icon: 'UsersIcon',
        level_sum: 2048,
    },
    {
        url: '/patient/list',
        name: '환자관리',
        icon: 'UsersIcon',
        level_sum: 1,
    },
    {
        url: '/patientSchedule/scheduleCalendar',
        name: '환자스케쥴',
        icon: 'UsersIcon',
        level_sum: 16384,
    },
    {
        url: '/ward/list',
        name: '병동 스케줄',
        icon: 'CalendarIcon',
        level_sum: 2,
    },
    {
        url: '/ward_status/list',
        name: '병동현황',
        icon: 'CalendarIcon',
        level_sum: 4,
    },
    {
        url: '/doctor/list',
        name: '원장님 스케줄',
        icon: 'CalendarIcon',
        level_sum: 8,
    },
    {
        url: '/doctor/patient/list',
        name: '담당환자 관리',
        icon: 'ArchiveIcon',
        level_sum: 8,
    },
    {
        url: '/cs/todo',
        name: '상담 내역',
        icon: 'CalendarIcon',
        level_sum: 1024,
    },

    {
        url: '/cure/list',
        name: '치료실 스케줄',
        icon: 'ClockIcon',
        level_sum: 16,
    },
    {
        url: '/vacation/schedule',
        name: '연차 관리',
        icon: 'CalendarIcon',
        level_sum: 131072,
    },
    {
        url: '/injection/list',
        name: '외래치료실 스케줄',
        icon: 'ClockIcon',
        level_sum: 32,
    },
    {
        url: '/remote/list',
        name: '(구)입퇴원/외래',
        icon: 'ClockIcon',
        level_sum: 64,
    },
    {
        url: '/remote/list2',
        name: '입퇴원List',
        icon: 'ClockIcon',
        level_sum: 4096,
    },
    {
        url: '/nutrition/list',
        name: '영양팀',
        icon: 'ClockIcon',
        level_sum: 8192,
    },
    {
        url: '/message/schedule',
        name: '외진스케쥴',
        icon: 'ArchiveIcon',
        level_sum: 128,
    },
    {
        url: null,
        name: '병원관리',
        icon: 'SettingsIcon',
        level_sum: 256,
        submenu: [
            {
                url: '/management/ward',
                name: '병동관리',
                slug: 'external',
                level_sum: 256,
            },
            {
                url: '/management/logHistory',
                name: '로그기록',
                slug: 'external',
                level_sum: 256,
            },
            // {
            //     url: '/management/treatmentRoom',
            //     name: '치료실관리',
            //     slug: 'external',
            //     level_sum: 256,
            // },
            {
                url: '/management/injectionRoom',
                name: '외래치료실관리',
                slug: 'external',
                level_sum: 256,
            },
            // {
            //     url: '/management/treatmentRoomNew',
            //     name: '치료실관리2',
            //     slug: 'external',
            //     level_sum: 256,
            // },
            // {
            //     url: '/management/directorRoom',
            //     name: '원장님관리',
            //     slug: 'external',
            //     level_sum: 256,
            // },
            {
                url: '/management/admin',
                name: '관리자관리',
                slug: 'external',
                level_sum: 128,
            },
            {
                url: '/management/kakaoHistory',
                name: '알림톡발송내역',
                slug: 'external',
                level_sum: 256,
            },
            {
                url: '/management/oxygenPoint',
                name: '포인트적립내역',
                slug: 'external',
                level_sum: 256,
            },
            {
                url: '/management/holiday',
                name: '휴일관리',
                slug: 'external',
                level_sum: 256,
            },
            {
                url: '/management/noticeList',
                name: '공지사항',
                slug: 'external',
                level_sum: 256,
            },
        ],
    },

    {
        url: '/meal/view',
        name: '식사관리',
        icon: 'ArchiveIcon',
        level_sum: 512,
    },
    {
        url: '/treatment/list',
        name: '실별스케쥴',
        icon: 'ClockIcon',
        level_sum: 32768,
    },
    {
        url: '/dashboard/main',
        name: '대시보드',
        icon: 'ArchiveIcon',
        level_sum: 65536,
    },
];
